var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shouldShowExpirationStatus)?_c('Pill',{class:{
      [_vm.$style.pillError]: _vm.isCertExpired,
      [_vm.$style.pillWarning]: _vm.isCertAboutToExpire,
    },attrs:{"text":_vm.expirationText}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }